import clsx from 'clsx'
import PropTypes from 'prop-types'
import { useEffect, useLayoutEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { useLocation, Link } from 'react-router-dom'

import styles from './style.module.scss'

/*
 * Abstand zwischen Menueleiste und Ausklappliste - genauso breit wie der
 * rechte Aussenabstand der Menueliste, damit die Liste buendig an der Leiste
 * anliegt wie zuvor.
 */
const ABSTAND = 10

export default function PopUpList(props) {
	const { pathname, search } = useLocation()
	const [position, setPosition] = useState(null)

	useEffect(() => {
		const handler = () => {
			if (props.isOpen) setTimeout(() => props.onClose(), 0)
		}
		document.addEventListener('mouseup', handler)
		return () => {
			document.removeEventListener('mouseup', handler)
		}
	})

	/*
	 * Die Liste haengt nicht mehr im Menue, sondern am Dokument. Die Menueliste
	 * hat seit dem Umbau eine eigene Bildlaufleiste und damit einen
	 * Rollbereich (overflow-x: hidden) - der schnitt die daneben liegende
	 * Ausklappliste restlos weg: Sie stand im Seitenaufbau, war aber nirgends
	 * zu sehen. Der Menuepunkt "Berichte" liess sich dadurch nicht oeffnen.
	 * Die Lage kommt jetzt vom Menuepunkt selbst.
	 */
	useLayoutEffect(() => {
		if (!props.isOpen) return undefined

		const platziere = () => {
			const anker = props.anchorRef?.current
			if (!anker) return

			const kasten = anker.getBoundingClientRect()
			setPosition({ top: kasten.top, left: kasten.right + ABSTAND })
		}

		platziere()
		window.addEventListener('resize', platziere)
		// Auch beim Rollen der Menueliste selbst - daher in der Erfassungsphase.
		window.addEventListener('scroll', platziere, true)

		return () => {
			window.removeEventListener('resize', platziere)
			window.removeEventListener('scroll', platziere, true)
		}
	}, [props.isOpen, props.anchorRef])

	if (!props.isOpen || !position) return null

	return createPortal(
		<nav
			className={styles.root}
			style={{
				top: position.top,
				left: position.left,
				// Sie bleibt im Bild, auch wenn der Menuepunkt weit unten steht.
				maxHeight: `calc(100vh - ${position.top}px - ${ABSTAND}px)`
			}}
		>
			{props?.popUpItems.map(item => (
				<Link
					key={item.name}
					to={item.to}
					className={clsx(
						styles.navItem,
						item.className,
						`${pathname}${search}` === item.to && styles.navItemActive
					)}
				>
					<span className={styles.navItemName}>{item.name}</span>
				</Link>
			))}
		</nav>,
		document.body
	)
}

PopUpList.propTypes = {
	isOpen: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	popUpItems: PropTypes.array.isRequired,
	// Der Menuepunkt, an dem die Liste haengt.
	anchorRef: PropTypes.object.isRequired
}
